interface ScoreDistributionChartProps {
  distribution: Record<string, number>;
}

const barColors: Record<string, string> = {
  '1-2': 'bg-red-400',
  '2-3': 'bg-orange-400',
  '3-4': 'bg-yellow-400',
  '4-5': 'bg-green-400',
};

export function ScoreDistributionChart({ distribution }: ScoreDistributionChartProps) {
  const entries = Object.entries(distribution);
  const maxCount = Math.max(...entries.map(([, v]) => v), 1);

  return (
    <div className="space-y-2">
      {entries.map(([range, count]) => (
        <div key={range} className="flex items-center gap-3">
          <span className="text-xs text-gray-500 w-8">{range}</span>
          <div className="flex-1 bg-gray-100 rounded-full h-5 overflow-hidden">
            <div
              className={`h-full rounded-full transition-all ${barColors[range] ?? 'bg-gray-400'}`}
              style={{ width: `${(count / maxCount) * 100}%` }}
            />
          </div>
          <span className="text-xs text-gray-600 w-8 text-right">{count}</span>
        </div>
      ))}
    </div>
  );
}
